import InnerBanner from '../components/common/InnerBanner'

const Careers = () => {
    return (
        <>
        <InnerBanner title={'Careers'} info={'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dignissim sapien at fringilla malesuada. Donec fringilla varius feugiat. Morbi et congue arcu. Mauris quis ultricies odio, at lacinia libero. '}/>
        </>
    );
};

export default Careers;